var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9107 5.45321C9.11094 4.08769 9.59796 2.72215 10.5618 1.68939C11.4171 0.791104 12.6152 0.756622 13.4755 1.6687C14.436 2.71353 14.867 4.09458 15.091 5.45149L15.0435 5.46873C14.5734 4.2463 14.0796 2.96182 13.1497 2.02216C11.9432 0.830769 10.7655 1.92905 10.0765 3.07216C9.61324 3.82044 9.25177 4.63424 8.9599 5.46873L8.9107 5.45321Z",
    fill: "#1A2129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70415 6.40513H2.82711L1.01815 19.9793L1.01475 20.0018C0.936691 20.7328 1.17088 21.4655 1.6596 22.0138C2.14832 22.5604 2.84746 22.8759 3.57885 22.8759H20.4211C21.1525 22.8759 21.8517 22.5621 22.3404 22.0138C22.8291 21.4655 23.0633 20.7328 22.9852 20.0018L21.1746 6.40683H7.70415V6.40513Z",
    stroke: "#BFC0C1",
    strokeWidth: 1.5,
    strokeMiterlimit: 100,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9107 5.45321C9.11094 4.08769 9.59796 2.72215 10.5618 1.68939C11.4171 0.791104 12.6152 0.756622 13.4755 1.6687C14.436 2.71353 14.867 4.09458 15.091 5.45149L15.0435 5.46873C14.5734 4.2463 14.0796 2.96182 13.1497 2.02216C11.9432 0.830769 10.7655 1.92905 10.0765 3.07216C9.61324 3.82044 9.25177 4.63424 8.9599 5.46873L8.9107 5.45321Z",
    stroke: "#BFC0C1",
    strokeWidth: 1.5,
    strokeMiterlimit: 100,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.2c522fbc51a515fa9acb6f1598e1c62c.svg";
export { ForwardRef as ReactComponent };